import React from "react";

export default function Footer() {
  return (
    <footer>
      <p className="center">&copy; Tacit Tech {new Date().getFullYear()}</p>
    </footer>
  );
}
